import { render, staticRenderFns } from "./geochat.vue?vue&type=template&id=7f8ce4eb"
import script from "./geochat.vue?vue&type=script&lang=ts"
export * from "./geochat.vue?vue&type=script&lang=ts"
import style0 from "./geochat.vue?vue&type=style&index=0&id=7f8ce4eb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VBtn,VContainer,VIcon,VMain})
